import { TASKS_PARTNER_FILTER_EVENTS } from './global-events';

export const tasksPartnerFilterOptions = [
  {
    id: 'all',
    name: 'Всі завдання',
    event: TASKS_PARTNER_FILTER_EVENTS.TASKS_PARTNER_FILTER_ALL,
    options: {
      type: 'checkbox',
    }
  },
];
